<template>
  <wh-popup
    v-model="myVisible"
    title="种植环节"
    @close="hidePopup"
    @submit="submit"
  >
    <div class="list">
      <div v-for="(item, key) in farmWorkRecords" :key="key" class="list-item" :class="{selected: item.selected, 'not-change': item.notChange}" @click="toggleSelect(item)">
        <van-icon class="checked-icon" name="checked" />
        <div class="card">
          <template v-if="item.notChange">
            <div class="name">
              {{ item.name }}
            </div>
            <div class="bottom-content">
              <div class="time">
                {{ formatTime(item.startDate, 'YYYY-MM-DD') }}
              </div>
            </div>
          </template>
          <template v-else>
            <div class="name">
              {{ item.farmWork }}
            </div>
            <div class="bottom-content">
              <div class="time">
                {{ formatTime(item.beginTime, 'YYYY-MM-DD') }}
              </div>
              <div class="operator">
                操作人：{{ item.operator }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </wh-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formatTime } from '@/utils/convert/convertTime'

export default {
  name: 'FarmWorkTracePopup',
  components: { WhPopup },
  mixins: [popup],
  props: {
    farmWorkRecords: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    formatTime,
    submit() {
      this.hidePopup()
      this.$emit('change', this.farmWorkRecords)
    },
    toggleSelect(item) {
      if (!item.notChange) {
        this.$set(item, 'selected', !item.selected)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.list {
  margin-top: 20px;
  .list-item {
    padding: 10px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.not-change {
      pointer-events: none;
      .checked-icon {
        color: @primary-color;
      }
      .card {
        box-shadow: none;
      }
    }
    &.selected {
      .checked-icon {
        color: @primary-color;
      }
    }
    .checked-icon {
      text-align: center;
      font-size: 20px;
      color: #ccc;
    }
    .card {
      border-radius: 4px;
      padding: 14px 10px;
      width: 86%;
      box-shadow: 0 0 10px 0 #ccc;
      .name {
        font-size: 20px;
        font-weight: bold;
      }
      .bottom-content {
        display: flex;
        justify-content: space-between;
        .time {
          padding: 1px 4px;
          background-image: linear-gradient(to right, #23bf7f, #51dc86);
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          margin-top: 10px;
        }
        .operator {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
